import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SliderHeader from 'jd-library/SliderHeader';
import Loader from 'jd-library/Loader';
import ContractListingRow from './ContractListingRow';
import {auditSearch} from '../../utills';
import queryString from 'query-string';
import {setAuditObject} from '../../actions/products';
import './ContractSearchPage.scss';
import useInfiniteScroll from 'jd-library/useInfiniteScroll';

const ContractSearchPage = props => {
    const [pageNo,updatePageNo] = useState(1);
    const [contractDummyData,updateContractData] = useState([]);
    const [allResultsLoaded,updateAllResults] = useState(false);
    const [bottomLoader, updateBottomLoader] = useState(false);
    let contractData = props.products.auditData.contractArr || [];
    let DisplayItem = [];

    const onContractClick = (data) => {
        let search = window.location.search;
        let queryObject = queryString.parse(search);
        queryObject.showResultBy = "products";
        queryObject.docId = data.docId;
        queryObject.searchBy = "docId";
        queryObject.loadedInIframe = window.top != window.self ? true : undefined;
        search = queryString.stringify(queryObject);
        let url = `${window.location.origin}/vendor/manage-products-genio/${data.token}/products?${search}&isAuditUrl=true&useAuditApi=true`;
        // if(data.isSpecialContract){
            url+="&isSpecialContract=true&actualToken="+data.token;
        // }
        window.location.href = url;
    };
    useEffect(() => {
        if(!props.products.auditData.contractArr) {
            let options = queryString.parse(window.location.search);
            options.cb = (data) => {
                if(data.data.status) {
                    updateContractData(data.data.data.data);
                    props.setAuditObject({
                        contractArr: data.data.data.data
                    });
                }
            };
            auditSearch(options);
        } else {
            if(props.products.auditData.contractArr) {
                updateContractData(props.products.auditData.contractArr);
            }
        }
    },[]);
    const [isFetching, setIsFetching] = useInfiniteScroll({
		loadMoreCB: () => {
            if(!allResultsLoaded){
                updateBottomLoader(true);
                let page = {pageNo:pageNo + 1}
                let options = queryString.parse(window.location.search);
                options = {...options,
                ...page}
                updatePageNo(pageNo + 1);
                options.cb = (data) => {
                    if(data.data.status) {
                        let result = contractDummyData;
                        if(data.data.data.data){
                            result = result.concat(data.data.data.data);
                        } else {
                            updateAllResults(true);
                            setIsFetching(false);
                            updateBottomLoader(false);
                            return;
                        }
                        updateContractData(result)
                        props.setAuditObject({
                            contractArr: result
                        });
                        setIsFetching(false);
                        updateBottomLoader(false);
                    }
                };
                auditSearch(options);
            }
        },
        deps:[],
        useWindow: true,
		threshold: 100
	});

    let noContractResult = !contractData.length;
    for(let i = 0;i<contractData.length;i++){
        DisplayItem.push(
            <ContractListingRow data = {contractData[i]} onClick = {onContractClick}></ContractListingRow>
        )
    }
	const leftIconArr = [
        {
            className: 'icon-hdrBackNew',
            onClick: () => {
                    window.history.back();
            }
        }
    ];
	return (<>
        <SliderHeader
            heading={'Contracts'}
            variant='secondary'
            leftIcons={leftIconArr}
        />
        {noContractResult ? (
        <div
            className={'no-contract-result-container'}
        >
            <img
                src={'https://image1.jdomni.in/jdomni_email/No_Result_Found_2004241256.png'}
                className={'no-result-img'}
            />
            <h3 className={'no-result-heading'}>
                No Result Found
            </h3>
        </div>
        ) : 
        (<div className={'contract-list-holder'} >
            {DisplayItem}
            {bottomLoader ? <div style={{height :"5.625rem", width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}} >
                <div style = {{padding: "0.313rem", borderRadius: "100%", boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 15px 0px"}} >
                    <Loader 
                        style ={{borderColor: "#3B74A9", borderTopColor: "white", height: "1.25rem", width: "1.25rem"}}
                    />
                </div>
            </div> : null}
        </div>)}
    </>);
};

const mapStateToProps = state => {
	return {
		...state
	};
};

export default connect(mapStateToProps,{setAuditObject})(ContractSearchPage);